import React, { useState } from "react";
import SearchBar from "./SearchBar";


const AddPropertySearchBar = ({ showAddPropertyButton = false }) => {  // false to see the Toggle button
  const [isActive, setIsActive] = useState(false);

  return (
    <div className="
    bg-white
      max-w-[1080px]
      w-full mx-auto
      max-h-[136px] sm:max-h-[6.5625rem] h-full p-[1.875rem] 
      rounded-lg shadow-md
      flex flex-col sm:flex-row sm:justify-between sm:items-center
      gap-3
    ">
      {/* SearchBar */}
      <div className="flex-1 min-w-0">
        <SearchBar placeholder="Search by property name" />
      </div>

      {/* Either Add Property Button or Toggle */}
      {showAddPropertyButton ? (
        <button
          className="
            min-w-[80px]
            max-w-[170px]
            w-auto
            h-[45px]
            sm:h-[55px]
            bg-[#4772F1] 
            border border-[#4772F1] 
            text-white 
            rounded-md
            text-base 
            font-semibold 
            flex 
            items-center 
            justify-center
            flex-shrink-0
            px-3
            self-start sm:self-auto
            "
        >
          <span className="hidden sm:inline">+ Add Property</span>
          <span className="sm:hidden">+ Add</span>
        </button>
      ) : (
        <div className="flex items-center justify-between w-[15.125rem] h-[2.8125rem] bg-white rounded-[5px] border border-[#CECECE] p-1 self-start sm:self-auto">
          <span className="ml-3 text-sm font-medium text-[#9D9D9D]">Auto-Reminders</span>
          <button
            onClick={() => setIsActive(!isActive)}
            className={`relative inline-flex items-center w-[3.1875rem] h-[1.5625rem] rounded-full transition-colors focus:outline-none ${
              isActive ? "bg-[#91AAF7]" : "bg-[#B5B5B5]"
            }`}
          >
            <span
              className={`inline-block w-[1.125rem] h-[1.125rem] bg-white rounded-full transform transition-transform drop-shadow-[4px_0px_5.5px_rgba(0,0,0,0.25)] ${
                isActive 
                  ? "translate-x-[1.800rem]" 
                  : "translate-x-[0.276875rem]"
              }`}
            />
          </button>
        </div>
      )}
    </div>
  );
};

export default AddPropertySearchBar;